const MODULE_HASHES_KEY = 'module_hashes';

export function getModuleHashes(): Record<string, string> {
  try {
    const raw = localStorage.getItem(MODULE_HASHES_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function setModuleHashes(hashes: Record<string, string>): void {
  localStorage.setItem(MODULE_HASHES_KEY, JSON.stringify(hashes));
}

export function clearModuleHashes(): void {
  localStorage.removeItem(MODULE_HASHES_KEY);
}
